export default "__VITE_ASSET__BZl4vhfu__"